.mainWrapper {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  grid-area: auto;
}

.sportsPageGridContentContainer {
  width: -webkit-fill-available;
  width: -moz-available;
  width: stretch;
  max-width: var(--ogm-max-width);
  margin-left: auto;
  margin-right: auto;
  margin-top: 20px;
  margin-bottom: 20px;
  display: grid;
  grid-template-areas:
    'centerTop'
    'centerBottom';
  grid-template-columns: 1fr;
  grid-template-rows: auto;
  gap: 20px;
  padding: 0 16px;
}

@media (min-width: 768px) {
  .sportsPageGridContentContainer {
    gap: 40px;
    margin-top: 40px;
    margin-bottom: 40px;
  }
}

/* The container's own top margin is inter-section spacing (breadcrumbs/header -> content grid) — when
   the inline-banner ad leads the content grid instead, that margin lands directly above the ad and
   reads as an oversized gap above it. Compound selector (two classes) beats the plain/media-query
   `.sportsPageGridContentContainer` rules above regardless of source order or breakpoint. */
.sportsPageGridContentContainer.leadsWithInlineBanner {
  margin-top: 15px;
}

.sportsPageGridCenterTop,
.sportsPageGridCenterBottom {
  display: flex;
  flex-direction: column;
  gap: 10px;
  overflow-x: hidden;
}

.sportsPageGridCenterTop:last-child,
.sportsPageGridCenterBottom:last-child {
  gap: 0;
}

.sportsPageGridCenterTop {
  grid-area: centerTop;
}

.sportsPageGridCenterBottom {
  grid-area: centerBottom;
}

.sportsPageGridContentContainer > *,
.sportsPageGridCenterTop > *,
.sportsPageGridCenterBottom > *,
.sportsPageGridBottom > * {
  max-width: 100%;
}

.mainWrapper.gridGroup {
  background-color: var(--ogm-ghostwhite);
}

.sportsPageGridContentContainer.gridGroup {
  padding: 0 0 20px 0;
  margin-top: 0;
  margin-bottom: 0;
}

.sportsPageGridContentContainer.gridGroup,
.sportsPageGridContentContainer.gridGroup .sportsPageGridCenterTop,
.sportsPageGridContentContainer.gridGroup .sportsPageGridCenterBottom {
  display: block;
  gap: 0;
  overflow-x: unset;
}

.sportsPageGridContentContainer.gridGroup .sportsPageGridCenterBottom {
  padding: 20px 16px 0 16px;
}
